import { render, staticRenderFns } from "./ManageRemindersModal.vue?vue&type=template&id=1ae329de"
import script from "./ManageRemindersModal.vue?vue&type=script&lang=ts"
export * from "./ManageRemindersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports